module.exports = __webpack_public_path__ + "img/DE02081.38413e79.png";